import * as THREE from 'three'
import React, { useMemo, useState } from 'react'

import { const_var, params } from '../../../../../../redux/reducers/reducer';
import { delModel, extrudeSettings, jTrimModel, wainscotTrimModel } from '../../../../../../utils/Functions';
import { CSG } from '../../../../../../assets/libs/csg-lib';
import { useDispatch, useSelector } from 'react-redux';
import { setWallCloseStateWrap } from '../../../../../../action';
import { controls } from '../../../../../../redux/reducers/eventReducer';

const TrimModel = () => {
    const dispatch = useDispatch();

    const wallCloseStateWrap = useSelector(state => state.reducer.wallCloseStateWrap)

    const [frontWallCloseSize, setFrontWallCloseSize] = useState(0);
    const [backWallCloseSize, setBackWallCloseSize] = useState(0);
    const [sideWallCloseSize, setSideWallCloseSize] = useState(0);
    const [sideWallLeftPorchSize, setSideWallLeftPorchSize] = useState(0);
    const [sideWallRightPorchSize, setSideWallRightPorchSize] = useState(0);
    const [offSetHeight, setOffSetHeight] = useState(0);
    const [thickness, setThickness] = useState(0);

    const offsetWithDoorThickness = 0.127;
    const wallThickness = 0.005

    let offset;
    
    const legDistance = useMemo(() => {
        return (const_var.DistanceArr.length>0 && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=undefined) ? const_var.DistanceArr[params.p_b_t][params.p_r_s] : 5
    }, [const_var.DistanceArr, params.p_b_t, params.p_r_s,params.fourth_center_cost,const_var.DistanceArr.length>0 && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=undefined && const_var.DistanceArr[params.p_b_t][params.p_r_s]])

    if(params.leanR_p_d % legDistance === 0) offset = 0.15;
    else offset = 0;

    const sideJTrimState = params.p_j_t && params.p_b_c_b_r !== "Open" && params.p_b_c_b_r !== "Close";
    const frontJTrimState = params.p_j_t_end && params.p_b_c_b_r_f !== "Open" && params.p_b_c_b_r_f !== "Close"  && params.p_b_c_b_r_f !== "Half Dutch End" && params.p_b_c_b_r_f !== "Half End";
    const backJTrimState = params.p_j_t_end && params.p_b_c_b_r_b !== "Open" && params.p_b_c_b_r_b !== "Close"  && params.p_b_c_b_r_b !== "Half Dutch End" && params.p_b_c_b_r_b !== "Half End";
    // const wainscotColor = useMemo(() => {
    //     if ((controls.isCheckActiveTab === 'doorwindow' && const_var.focusedSection !== 'rightlean') || (params.is_translusant)) {
    //         return 'white'
    //     } else {
    //         return params.p_w_c_c.replace("0x","#");
    //     }
    // }, [params.p_w_c_c, controls.isCheckActiveTab, const_var.focusedSection, params.is_translusant])
    const wainscotColor = useMemo(() => (params.p_w_c_c.replace("0x","#")), [params.p_w_c_c]) 
    
    const trimOffset = useMemo(() => {
        if(params.p_b_c_b_r === 'Open') return 0;
        else return 0.2;
    }, [params.p_b_c_b_r])
    
    // const alignPosOffset = useMemo(() => {
    //     if( Number(params.leantoAlignmentRight) === 1 ) return 0;
    //     else if( Number(params.leantoAlignmentRight) === 2 ) return -params.p_d / 2 + params.leanR_p_d / 2;
    //     else if( Number(params.leantoAlignmentRight) === 3 ) return  params.p_d / 2 - params.leanR_p_d / 2;
    //     else return 0
    // }, [params.leantoAlignmentRight, params.p_d, params.leanR_p_d, params.leanR_p_pos])
    
    const frontWallVrTrimModel = useMemo(() => {
        const model = new THREE.Shape();

        if (!(params.p_b_c_b_r_f === "Open" || params.p_b_c_b_r_f === "Gable" || params.add_right_front_lean_porch || params.p_b_c_b_r === 'Close')) {
            model.moveTo(-(params.leanR_p_d / 2), params.leanR_p_h + offSetHeight);
            model.lineTo(-(params.leanR_p_d / 2), frontWallCloseSize);
            model.lineTo(-(params.leanR_p_d / 2 + 0.23), frontWallCloseSize);
            model.lineTo(-(params.leanR_p_d / 2 + 0.23), params.leanR_p_h + offSetHeight);
            model.closePath();
        }

        return model;
    }, [frontWallCloseSize, params.p_b_c_b_r_f, params.add_right_front_lean_porch, params.leanR_p_h, params.leanR_p_d, offSetHeight, params.p_b_c_b_r])

    const rightLeanFrontTrimModel = useMemo(() => {
        const model = new THREE.Shape();
        if(params.p_r_w === 'Open' && params.p_b_c_b_r_f !== 'Open' && !params.add_front_lean && (params.leanR_p_d === params.p_d || (params.leanR_p_d !== params.p_d && Number(params.leantoAlignmentRight) === 2))){
            model.moveTo(-(params.p_d / 2 + 0.26), wallCloseStateWrap.RLFrontWallCloseState);
            model.lineTo(-(params.p_d / 2 + 0.26), params.p_h) 
            model.lineTo(-(params.p_d / 2 + 0.03), params.p_h)
            model.lineTo(-(params.p_d / 2 + 0.03), wallCloseStateWrap.RLFrontWallCloseState);
            model.closePath();
        }
        return model;
    
    }, [params.p_h, params.p_d, wallCloseStateWrap.RLFrontWallCloseState, params.p_r_w, params.p_b_c_b_r_f, params.add_front_lean, params.leanR_p_d, params.leantoAlignmentRight])

    const rightLeanBackTrimModel = useMemo(() => {
        const model = new THREE.Shape();
        if(params.p_r_w === 'Open' && params.p_b_c_b_r_b !== 'Open' && !params.add_back_lean && (params.leanR_p_d === params.p_d || (params.leanR_p_d !== params.p_d && Number(params.leantoAlignmentRight) === 3))){
            model.moveTo(params.p_d / 2 + 0.03, wallCloseStateWrap.RLBackWallCloseState);
            model.lineTo(params.p_d / 2 + 0.03, params.p_h) 
            model.lineTo(params.p_d / 2 + 0.26, params.p_h)
            model.lineTo(params.p_d / 2 + 0.26, wallCloseStateWrap.RLBackWallCloseState);
            model.closePath();
        }
        return model;
    
    }, [params.p_h, params.p_d, wallCloseStateWrap.RLBackWallCloseState, params.p_r_w, params.p_b_c_b_r_b, params.add_back_lean, params.leanR_p_d, params.leantoAlignmentRight])

    const dutchDelModelFront = useMemo(() => {
        const freeSpace = 1;
        const trimWidth = 0.2;
        const offset = 0.05 * Math.pow(2, 1 / 2)
        let cornerFreeSpaceW = (params.leanR_p_w - freeSpace) / 6;
        const leftHeight = (params.singleSlope && params.freeStandingSide === "left") ? params.leanR_p_h :  params.leanR_p_h;
        let cornerFreeSpaceH = (leftHeight - freeSpace) / 6
        if (cornerFreeSpaceH > freeSpace) cornerFreeSpaceH = freeSpace * 2;

        if (cornerFreeSpaceW > freeSpace) cornerFreeSpaceW = freeSpace * 2;
        
        if (params.add_right_lean && (params.p_b_c_b_r_f === "Half Dutch End" || params.p_b_c_b_r_f === "Half End")) {
            const model = new THREE.Shape();
            model.moveTo(-(params.leanR_p_w / 2 - freeSpace), 0);

            if (params.p_b_c_b_r_f === "Half Dutch End") {
                model.lineTo(-(params.leanR_p_w / 2 - freeSpace), leftHeight - freeSpace - cornerFreeSpaceH);
                model.lineTo(-(params.leanR_p_w / 2 - freeSpace - cornerFreeSpaceW), leftHeight - freeSpace);
                model.lineTo((params.leanR_p_w / 2 - freeSpace - cornerFreeSpaceW), leftHeight - freeSpace);
                model.lineTo((params.leanR_p_w / 2 - freeSpace), leftHeight - freeSpace - cornerFreeSpaceH);
                model.lineTo((params.leanR_p_w / 2 - freeSpace), 0);
                model.lineTo((params.leanR_p_w / 2 - freeSpace - trimWidth), 0);
                model.lineTo((params.leanR_p_w / 2 - freeSpace - trimWidth), leftHeight - freeSpace - cornerFreeSpaceH - offset * Math.pow(2, 1 / 2));
                model.lineTo((params.leanR_p_w / 2 - freeSpace - cornerFreeSpaceW - offset), leftHeight - freeSpace - trimWidth);
                model.lineTo(-(params.leanR_p_w / 2 - freeSpace - cornerFreeSpaceW - offset), leftHeight - freeSpace - trimWidth);
                model.lineTo(-(params.leanR_p_w / 2 - freeSpace - trimWidth), leftHeight - freeSpace - cornerFreeSpaceH - offset * Math.pow(2, 1 / 2));
            } else {
                model.lineTo(-(params.leanR_p_w / 2 - freeSpace), leftHeight - freeSpace);
                model.lineTo((params.leanR_p_w / 2 - freeSpace), leftHeight - freeSpace);
                model.lineTo((params.leanR_p_w / 2 - freeSpace), 0);
                model.lineTo((params.leanR_p_w / 2 - freeSpace - trimWidth), 0);
                model.lineTo((params.leanR_p_w / 2 - freeSpace - trimWidth), leftHeight - freeSpace - trimWidth);
                model.lineTo(-(params.leanR_p_w / 2 - freeSpace - trimWidth), leftHeight - freeSpace - trimWidth);
            }
            model.lineTo(-(params.leanR_p_w / 2 - freeSpace - trimWidth), 0);
            model.closePath()

            return model;
        } else {
            return []
        }
    }, [params.add_right_lean, params.leanR_p_w, params.leanR_p_h, params.p_b_c_b_r_f])


    const dutchDelModelBack = useMemo(() => {
        const freeSpace = 1;
        const trimWidth = 0.2;
        const offset = 0.05 * Math.pow(2, 1 / 2)
        let cornerFreeSpaceW = (params.leanR_p_w - freeSpace) / 6;
        const leftHeight = (params.singleSlope && params.freeStandingSide === "left") ? params.leanR_p_h :  params.leanR_p_h;
        let cornerFreeSpaceH = (leftHeight - freeSpace) / 6
        if (cornerFreeSpaceH > freeSpace) cornerFreeSpaceH = freeSpace * 2;

        if (cornerFreeSpaceW > freeSpace) cornerFreeSpaceW = freeSpace * 2;
        
        if (params.add_right_lean && (params.p_b_c_b_r_b === "Half Dutch End" || params.p_b_c_b_r_b === "Half End")) {
            const model = new THREE.Shape();
            model.moveTo(-(params.leanR_p_w / 2 - freeSpace), 0);

            if (params.p_b_c_b_r_b === "Half Dutch End") {
                model.lineTo(-(params.leanR_p_w / 2 - freeSpace), leftHeight - freeSpace - cornerFreeSpaceH);
                model.lineTo(-(params.leanR_p_w / 2 - freeSpace - cornerFreeSpaceW), leftHeight - freeSpace);
                model.lineTo((params.leanR_p_w / 2 - freeSpace - cornerFreeSpaceW), leftHeight - freeSpace);
                model.lineTo((params.leanR_p_w / 2 - freeSpace), leftHeight - freeSpace - cornerFreeSpaceH);
                model.lineTo((params.leanR_p_w / 2 - freeSpace), 0);
                model.lineTo((params.leanR_p_w / 2 - freeSpace - trimWidth), 0);
                model.lineTo((params.leanR_p_w / 2 - freeSpace - trimWidth), leftHeight - freeSpace - cornerFreeSpaceH - offset * Math.pow(2, 1 / 2));
                model.lineTo((params.leanR_p_w / 2 - freeSpace - cornerFreeSpaceW - offset), leftHeight - freeSpace - trimWidth);
                model.lineTo(-(params.leanR_p_w / 2 - freeSpace - cornerFreeSpaceW - offset), leftHeight - freeSpace - trimWidth);
                model.lineTo(-(params.leanR_p_w / 2 - freeSpace - trimWidth), leftHeight - freeSpace - cornerFreeSpaceH - offset * Math.pow(2, 1 / 2));
            } else {
                model.lineTo(-(params.leanR_p_w / 2 - freeSpace), leftHeight - freeSpace);
                model.lineTo((params.leanR_p_w / 2 - freeSpace), leftHeight - freeSpace);
                model.lineTo((params.leanR_p_w / 2 - freeSpace), 0);
                model.lineTo((params.leanR_p_w / 2 - freeSpace - trimWidth), 0);
                model.lineTo((params.leanR_p_w / 2 - freeSpace - trimWidth), leftHeight - freeSpace - trimWidth);
                model.lineTo(-(params.leanR_p_w / 2 - freeSpace - trimWidth), leftHeight - freeSpace - trimWidth);
            }
            model.lineTo(-(params.leanR_p_w / 2 - freeSpace - trimWidth), 0);
            model.closePath()

            return model;
        } else {
            return []
        }
    }, [params.add_right_lean, params.leanR_p_w, params.leanR_p_h, params.p_b_c_b_r_b])

    const backWallVrTrimModel = useMemo(() => {
        const model = new THREE.Shape();

        if (!(params.p_b_c_b_r_b === "Open" || params.p_b_c_b_r_b === "Gable" || (params.add_right_back_lean_porch && !params.add_storage_check_right) || params.p_b_c_b_r === 'Close')) {
            if(params.p_b_c_b_r !== 'Close' && params.add_right_back_lean_porch){
                model.moveTo(params.leanR_p_d / 2, backWallCloseSize);
                model.lineTo(params.leanR_p_d / 2, sideWallCloseSize);
                model.lineTo(params.leanR_p_d / 2 + 0.23, sideWallCloseSize);
                model.lineTo(params.leanR_p_d / 2 + 0.23, backWallCloseSize);
                model.closePath();
            } else {
                model.moveTo(params.leanR_p_d / 2, backWallCloseSize);
                model.lineTo(params.leanR_p_d / 2, params.leanR_p_h + offSetHeight);
                model.lineTo(params.leanR_p_d / 2 + 0.23, params.leanR_p_h + offSetHeight);
                model.lineTo(params.leanR_p_d / 2 + 0.23, backWallCloseSize);
                model.closePath();
            }
        }

        return model;
    }, [params.add_storage_check_right, backWallCloseSize, params.p_b_c_b_r_b, params.add_right_back_lean_porch, params.leanR_p_h, params.leanR_p_d, offSetHeight, params.p_b_c_b_r, sideWallCloseSize])

    const backWallVrTrimModelTwo = useMemo(() => {
        const model = new THREE.Shape();

        if (!(params.p_b_c_b_r_b === "Open" || params.p_b_c_b_r_b === "Gable" || (params.add_right_back_lean_porch && !params.add_storage_check_right) || params.p_b_c_b_r === 'Close')) {
            model.moveTo(params.leanR_p_d / 2 + 0.02, 0);
            model.lineTo(params.leanR_p_d / 2 + 0.02, sideWallCloseSize - offSetHeight + trimOffset + thickness - 0.1);
            model.lineTo(params.leanR_p_d / 2 + 0.23, sideWallCloseSize - offSetHeight + trimOffset + thickness - 0.1);
            model.lineTo(params.leanR_p_d / 2 + 0.23, 0);
            model.closePath();
        }

        return model;
    }, [params.add_storage_check_right, sideWallCloseSize, params.p_b_c_b_r_b, params.add_right_back_lean_porch, params.leanR_p_h, params.leanR_p_d, offSetHeight, params.p_b_c_b_r, trimOffset])
    
    const sideWallVrLeftTrimModel = useMemo(() => {
        const model = new THREE.Shape();

        if (!(params.p_b_c_b_r === "Open")) {
            model.moveTo(params.leanR_p_d / 2 + sideWallLeftPorchSize, sideWallCloseSize);
            model.lineTo(params.leanR_p_d / 2 + sideWallLeftPorchSize, params.leanR_p_h + offSetHeight);
            model.lineTo(params.leanR_p_d / 2 + sideWallLeftPorchSize + 0.23, params.leanR_p_h + offSetHeight);
            model.lineTo(params.leanR_p_d / 2 + sideWallLeftPorchSize + 0.23, sideWallCloseSize);
            model.closePath();
        }

        return model;
    }, [params.leanR_p_h, params.leanR_p_d, offSetHeight, sideWallCloseSize, sideWallLeftPorchSize, params.p_b_c_b_r])
    
    const sideWallVrRightTrimModel = useMemo(() => {
        const model = new THREE.Shape();

        if (!(params.p_b_c_b_r === "Open")) {
            model.moveTo(-(params.leanR_p_d / 2 + sideWallRightPorchSize + 0.235), sideWallCloseSize);
            model.lineTo(-(params.leanR_p_d / 2 + sideWallRightPorchSize + 0.235), params.leanR_p_h + offSetHeight);
            model.lineTo(-(params.leanR_p_d / 2 + sideWallRightPorchSize + 0), params.leanR_p_h + offSetHeight);
            model.lineTo(-(params.leanR_p_d / 2 + sideWallRightPorchSize + 0), sideWallCloseSize);
            model.closePath();
        }

        return model;
    }, [params.leanR_p_h, params.leanR_p_d, offSetHeight, sideWallCloseSize, sideWallRightPorchSize, params.p_b_c_b_r])

    // const sideWallJTrimModel = useMemo(() => {
    //     if (!(params.p_b_c_b_r === "Open" || params.p_b_c_b_r === "Close")) {
    //         let model = [];

    //         if (params.add_storage_check_right) {
    //             const leftTrimModel = new THREE.Shape();
    //             leftTrimModel.moveTo((params.leanR_p_d / 2 + sideWallLeftPorchSize + 0.18), sideWallCloseSize - 0.05);
    //             leftTrimModel.lineTo((params.leanR_p_d / 2 + sideWallLeftPorchSize + 0.18), sideWallCloseSize + 0.05);
    //             leftTrimModel.lineTo((params.leanR_p_d / 2 + 0.03), sideWallCloseSize + 0.05);
    //             leftTrimModel.lineTo((params.leanR_p_d / 2 + 0.03), sideWallCloseSize - 0.05);
    //             leftTrimModel.closePath();                

    //             const rightTrimModel = new THREE.Shape();
    //             rightTrimModel.moveTo((params.leanR_p_d / 2 - parseInt(params.add_storage_right)), sideWallCloseSize - 0.05);
    //             rightTrimModel.lineTo((params.leanR_p_d / 2 - parseInt(params.add_storage_right)), sideWallCloseSize + 0.05);
    //             rightTrimModel.lineTo(-(params.leanR_p_d / 2 + sideWallRightPorchSize + 0.18), sideWallCloseSize + 0.05);
    //             rightTrimModel.lineTo(-(params.leanR_p_d / 2 + sideWallRightPorchSize + 0.18), sideWallCloseSize - 0.05);
    //             rightTrimModel.closePath();

    //             model.push(leftTrimModel);
    //             model.push(rightTrimModel);
    //         } else {
    //             const trimModel = new THREE.Shape();
    //             trimModel.moveTo(-(params.leanR_p_d / 2 + sideWallRightPorchSize + 0.18), sideWallCloseSize - 0.05);
    //             trimModel.lineTo(-(params.leanR_p_d / 2 + sideWallRightPorchSize + 0.18), sideWallCloseSize + 0.05);
    //             trimModel.lineTo((params.leanR_p_d / 2 + sideWallLeftPorchSize + 0.18), sideWallCloseSize + 0.05);
    //             trimModel.lineTo((params.leanR_p_d / 2 + sideWallLeftPorchSize + 0.18), sideWallCloseSize - 0.05);
    //             trimModel.closePath();

    //             model.push(trimModel);
    //         }

    //         return model;
    //     } else {
    //         const model = new THREE.Shape();
    //         return model;
    //     }


    // }, [params.add_storage_check_right, params.leanR_p_d, sideWallCloseSize, sideWallLeftPorchSize, sideWallRightPorchSize, params.p_b_c_b_r, params.add_storage_right])

    const jTrimSideModelObj = useMemo(() => {
        let main;
        let wainscot;

        const storageVal = params.add_storage_check_right ? Number(params.add_storage_right) : 0

        /**********************cutting hole using CSG for side j-trim************************/

        const storageDelShape = new THREE.Shape();
            storageDelShape.moveTo(params.leanR_p_d / 2, 0);
            storageDelShape.lineTo(params.leanR_p_d / 2, params.leanR_p_h);
            storageDelShape.lineTo(params.leanR_p_d / 2 - parseInt(params.add_storage_right) - 0.12, params.leanR_p_h)
            storageDelShape.lineTo(params.leanR_p_d / 2 - parseInt(params.add_storage_right) - 0.12, 0);
            storageDelShape.closePath();

        const meshJTrimModel = new THREE.Mesh(new THREE.ExtrudeGeometry(jTrimModel(0.14, 0.2), extrudeSettings(params.leanR_p_d + sideWallLeftPorchSize + sideWallRightPorchSize + 0.2)), new THREE.MeshStandardMaterial({color: 'red'}))
        const meshDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('rightLeanSide', 'wall'), extrudeSettings(1)) , new THREE.MeshStandardMaterial({color: 'blue'}))
        const meshStorageDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(storageDelShape, extrudeSettings(0.4)))

        const meshJTrimCutModel_Temp = meshStorageDelModel.clone();
        meshJTrimCutModel_Temp.position.set(0, 0, -0.05)
        meshJTrimCutModel_Temp.updateMatrixWorld();

        const meshJTrimModel_Temp = meshJTrimModel.clone();
        // meshJTrimModel_Temp.position.set(0, 0.05, 0.1)
        meshJTrimModel_Temp.position.set((params.leanR_p_d / 2 + sideWallLeftPorchSize + 0.15), sideWallCloseSize + 0.1, 0.0925)
        meshJTrimModel_Temp.rotation.y = -Math.PI / 2
        meshJTrimModel_Temp.updateMatrixWorld()

        const meshDelModel_Temp = meshDelModel.clone();
        meshDelModel_Temp.position.set(params.leanR_p_pos, 0, -0.5);
        meshDelModel_Temp.updateMatrixWorld()
        

        const meshJTrimModel_CSG = CSG.fromMesh(meshJTrimModel_Temp);
        const meshDelModel_CSG = CSG.fromMesh(meshDelModel_Temp);

        const meshJTrimCutModel_CSG = CSG.fromMesh(meshJTrimCutModel_Temp)
        
        const JTrimModel_CSG_Temp = meshJTrimModel_CSG.subtract(meshDelModel_CSG);

        let JTrimModel_CSG;
        if(params.add_storage_check_right) {
            JTrimModel_CSG = JTrimModel_CSG_Temp.subtract(meshJTrimCutModel_CSG)
        } else {
            JTrimModel_CSG = JTrimModel_CSG_Temp
        }

        const CSGJTrimSideModel = CSG.toMesh( JTrimModel_CSG, new THREE.Matrix4())
        
        main = CSGJTrimSideModel.geometry 

        /**********************cutting hole using CSG Side wainscot trim************************/
        const sideWainscotTrimRightPorchSize = (params.add_right_front_lean_porch && params.p_b_c_b_r == "Close") ? sideWallRightPorchSize : 0
        const sideWainscotTrimLeftPorchSize = (params.add_right_back_lean_porch && params.p_b_c_b_r == "Close") ? sideWallLeftPorchSize : 0
        const storageLength = (params.add_storage_check_right && params.p_b_c_b_r != "Close") ? params.leanR_p_d - storageVal : 0
    
        const meshWainscotTrimModel = new THREE.Mesh(new THREE.ExtrudeGeometry(wainscotTrimModel(0.14, 0.17), extrudeSettings(params.leanR_p_d - storageLength + sideWainscotTrimRightPorchSize + sideWainscotTrimLeftPorchSize)), new THREE.MeshStandardMaterial({color: 'red'}))

        const meshWainscotTrimModel_Temp = meshWainscotTrimModel.clone();
        meshWainscotTrimModel_Temp.position.set((params.leanR_p_d / 2 + sideWainscotTrimLeftPorchSize), 3 , 0.1)
        meshWainscotTrimModel_Temp.rotation.y = Math.PI/-2
        meshWainscotTrimModel_Temp.updateMatrixWorld()

        const meshWainscotTrimModel_CSG = CSG.fromMesh(meshWainscotTrimModel_Temp);

        const WainscotTrimModel_CSG = meshWainscotTrimModel_CSG.subtract(meshDelModel_CSG);
        const CSGWainscotTrimSideModel = CSG.toMesh(WainscotTrimModel_CSG,new THREE.Matrix4())

        wainscot = CSGWainscotTrimSideModel.geometry;
        
        return {main, wainscot}
    }, [params.leanR_p_pos, params.leanR_p_d, params.leanR_p_h, params.add_storage_right, params.add_storage_check_right, sideWallLeftPorchSize, sideWallRightPorchSize, params.add_right_front_lean_porch, params.add_right_back_lean_porch, params.p_b_c_b_r, sideWallCloseSize, const_var.newDoorsArray])

    const jTrimFrontModelObj = useMemo(() => {
        let main;
        let wainscot;

         /**********************cutting hole using CSG for Front************************/ 
        const meshJTrimFrontModel = new THREE.Mesh(new THREE.ExtrudeGeometry(jTrimModel(0.14, 0.2), extrudeSettings(params.leanR_p_w)), new THREE.MeshStandardMaterial({color: 'red'}))
        const meshDelFrontModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('rightLeanFront', 'wall'), extrudeSettings(1)) , new THREE.MeshStandardMaterial({color: 'blue'}))
        const meshSideDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('rightLeanSide', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'green' }))

        const meshJTrimFrontModel_Temp = meshJTrimFrontModel.clone();
        meshJTrimFrontModel_Temp.position.set((-(params.leanR_p_d / 2 + 0.1525)), frontWallCloseSize + 0.1, 0.1)
        meshJTrimFrontModel_Temp.rotation.y = -Math.PI
        meshJTrimFrontModel_Temp.updateMatrixWorld()

        const meshDelFrontModel_Temp = meshDelFrontModel.clone();
        meshDelFrontModel_Temp.rotateY(Math.PI / -2);
        meshDelFrontModel_Temp.position.set(-(params.leanR_p_d / 2), 0, -(params.leanR_p_w) - params.p_w/2 + 0.1);
        meshDelFrontModel_Temp.updateMatrixWorld()

        let meshSideDelModel_Temp = meshSideDelModel.clone();
        meshSideDelModel_Temp.position.set(0, 0, -0.1 - params.leanR_p_pos);
        meshSideDelModel_Temp.updateMatrixWorld();

        const meshJTrimFrontModel_CSG = CSG.fromMesh(meshJTrimFrontModel_Temp);
        const meshDelFrontModel_CSG = CSG.fromMesh(meshDelFrontModel_Temp);
        const meshSideDelModel_CSG = CSG.fromMesh(meshSideDelModel_Temp);

        const JTrimFrontModel_CSG = meshJTrimFrontModel_CSG.subtract(meshDelFrontModel_CSG);
        const JTrimSideDelModel_CSG = JTrimFrontModel_CSG.subtract(meshSideDelModel_CSG);

        const CSGJTrimFrontModel = CSG.toMesh(JTrimSideDelModel_CSG, new THREE.Matrix4())

        main = CSGJTrimFrontModel.geometry

        /************** cutting hole in wainscot Trim using CSG for Front***************/

        const meshFrontWainscotModel = new THREE.Mesh(new THREE.ExtrudeGeometry(wainscotTrimModel(0.14, 0.17), extrudeSettings(params.leanR_p_w)))
        let meshFrontWainscotModel_Temp = meshFrontWainscotModel.clone();
        meshFrontWainscotModel_Temp.position.set(-(params.leanR_p_d / 2 + 0.155), 3 , 0.1)
        meshFrontWainscotModel_Temp.rotation.y = Math.PI
        meshFrontWainscotModel_Temp.updateMatrixWorld();

        const meshFrontWainscotModel_CSG = CSG.fromMesh(meshFrontWainscotModel_Temp);

        const frontWainscotModel_CSG = meshFrontWainscotModel_CSG.subtract(meshDelFrontModel_CSG);
        const SideDelModel_CSG = frontWainscotModel_CSG.subtract(meshSideDelModel_CSG);

        const CSGWainscotTrimFrontModel = CSG.toMesh(SideDelModel_CSG,new THREE.Matrix4())

        wainscot = CSGWainscotTrimFrontModel.geometry

        return {main, wainscot}

    }, [params.leanR_p_w, params.leanR_p_d, frontWallCloseSize, params.p_w, const_var.newDoorsArray, params.leanR_p_pos])

    const jTrimBackModelObj = useMemo(() => {
        let main;
        let wainscot;
    
        /**********************cutting hole using CSG for Back************************/ 
        const meshJTrimBackModel = new THREE.Mesh(new THREE.ExtrudeGeometry(jTrimModel(0.14, 0.2), extrudeSettings(params.leanR_p_w)), new THREE.MeshStandardMaterial({color: 'red'}))
        const meshDelBackModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('rightLeanBack', 'wall'), extrudeSettings(1)) , new THREE.MeshStandardMaterial({color: 'blue'}))
        const meshSideDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('rightLeanSide', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'green' }))

        const meshJTrimBackModel_Temp = meshJTrimBackModel.clone();
        meshJTrimBackModel_Temp.position.set((params.leanR_p_d / 2 + 0.1525), backWallCloseSize + 0.1, -params.leanR_p_w + 0.1)
        meshJTrimBackModel_Temp.updateMatrixWorld()

        const meshDelBackModel_Temp = meshDelBackModel.clone();
        meshDelBackModel_Temp.rotateY(Math.PI / -2);
        meshDelBackModel_Temp.position.set((params.leanR_p_d / 2) + 0.5, 0, -(params.leanR_p_w) - params.p_w/2 + 0.1);
        meshDelBackModel_Temp.updateMatrixWorld()

        let meshSideDelModel_Temp = meshSideDelModel.clone();
        meshSideDelModel_Temp.position.set(0, 0, -0.1 - params.leanR_p_pos);
        meshSideDelModel_Temp.updateMatrixWorld();

        const meshJTrimBackModel_CSG = CSG.fromMesh(meshJTrimBackModel_Temp);
        const meshDelBackModel_CSG = CSG.fromMesh(meshDelBackModel_Temp);
        const meshSideDelModel_CSG = CSG.fromMesh(meshSideDelModel_Temp);

        const JTrimBackModel_CSG = meshJTrimBackModel_CSG.subtract(meshDelBackModel_CSG);
        const JTrimSideDelModel_CSG = JTrimBackModel_CSG.subtract(meshSideDelModel_CSG);

        const CSGJTrimBackModel = CSG.toMesh(JTrimSideDelModel_CSG, new THREE.Matrix4())
        
        main = CSGJTrimBackModel.geometry

         /************** cutting hole in wainscot Trim using CSG for Front***************/

         const meshBackWainscotModel = new THREE.Mesh(new THREE.ExtrudeGeometry(wainscotTrimModel(0.14, 0.17), extrudeSettings(params.leanR_p_w + 0.01)))
         let meshBackWainscotModel_Temp = meshBackWainscotModel.clone();
         meshBackWainscotModel_Temp.position.set((params.leanR_p_d / 2 + 0.1525), 3 , -(params.leanR_p_w) + 0.098)
         // meshBackWainscotModel_Temp.rotation.y = Math.PI
         meshBackWainscotModel_Temp.updateMatrixWorld();
 
         const meshBackWainscotModel_CSG = CSG.fromMesh(meshBackWainscotModel_Temp);
 
         const backWainscotModel_CSG = meshBackWainscotModel_CSG.subtract(meshDelBackModel_CSG);
        const SideDelModel_CSG = backWainscotModel_CSG.subtract(meshSideDelModel_CSG);

         const CSGWainscotTrimBackModel = CSG.toMesh(SideDelModel_CSG,new THREE.Matrix4())
 
         wainscot = CSGWainscotTrimBackModel.geometry

         return {main, wainscot}

        }, [params.leanR_p_w, params.leanR_p_d, backWallCloseSize, params.p_w, const_var.newDoorsArray, params.leanR_p_pos])


    const storageFrontWall = useMemo(() => {
        const meshStorageFrontWainscotModel = new THREE.Mesh(new THREE.ExtrudeGeometry(wainscotTrimModel(0.14, 0.17), extrudeSettings(params.leanR_p_w - offsetWithDoorThickness + 0.09)))
        const meshFrontStorageDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('rightLeanStorageFront', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'green' }))
        const meshSideDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('rightLeanSide', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'red' }));

        let meshStorageFrontWainscotModel_Temp = meshStorageFrontWainscotModel.clone();
        meshStorageFrontWainscotModel_Temp.position.set((params.leanR_p_d / 2  - parseInt(params.add_storage_right)), 3, 0.09)
        meshStorageFrontWainscotModel_Temp.rotation.y = Math.PI
        meshStorageFrontWainscotModel_Temp.updateMatrixWorld();

        let meshFrontStorageDelModel_Temp = meshFrontStorageDelModel.clone();
        meshFrontStorageDelModel_Temp.position.set((params.leanR_p_d / 2  - parseInt(params.add_storage_right)) + 0.5, 0, -( params.p_w/2 + params.leanR_p_w - 0.1));
        meshFrontStorageDelModel_Temp.rotation.y = Math.PI/-2
        meshFrontStorageDelModel_Temp.updateMatrixWorld();

        let meshSideDelModel_Temp = meshSideDelModel.clone();
        meshSideDelModel_Temp.position.set(0, 0, -0.15 - params.leanR_p_pos);
        meshSideDelModel_Temp.updateMatrixWorld();

        const meshStorageFrontWainscotModel_CSG = CSG.fromMesh(meshStorageFrontWainscotModel_Temp);
        const meshFrontStorageDelModel_CSG = CSG.fromMesh(meshFrontStorageDelModel_Temp);
        const meshSideDelModel_CSG = CSG.fromMesh(meshSideDelModel_Temp);

        const storagefrontWainscotModel_CSG = meshStorageFrontWainscotModel_CSG.subtract(meshFrontStorageDelModel_CSG);
        const storageSideWallDelModel_CSG = storagefrontWainscotModel_CSG.subtract(meshSideDelModel_CSG);

        const CSGStorageFrontWainscotModel = CSG.toMesh(storageSideWallDelModel_CSG,new THREE.Matrix4())

        return CSGStorageFrontWainscotModel.geometry


    }, [params.leanR_p_w, params.leanR_p_d, params.add_storage_right, const_var.newDoorsArray, params.leanR_p_pos])
    
    // --- front wall set    
    useMemo(() => {
        let tempWallCloseSize;
        if (params.p_b_c_b_r_f === "One_Fourth_Close") {
            tempWallCloseSize = params.leanR_p_h / 4 * 3;
        } else if (params.p_b_c_b_r_f === "Gable") {
            tempWallCloseSize = params.leanR_p_h - 0.2;
        } else if (params.p_b_c_b_r_f === "Half_Close") {
            tempWallCloseSize = params.leanR_p_h / 2;
        } else if (params.p_b_c_b_r_f === "Three_Fourth_Close") {
            tempWallCloseSize = params.leanR_p_h / 4;
        } else if (params.p_b_c_b_r_f === "Close") {
            tempWallCloseSize = 0;
        } else if (params.p_b_c_b_r_f === "Half Dutch End") {
            tempWallCloseSize = 0;
        } else if (params.p_b_c_b_r_f === "Half End") {
            tempWallCloseSize = 0;
        } else {
            tempWallCloseSize = -1;
        }

        setFrontWallCloseSize(tempWallCloseSize);
        dispatch(setWallCloseStateWrap({'RLFrontWallCloseState': tempWallCloseSize}))
    }, [params.p_b_c_b_r_f, params.leanR_p_h, params.p_r_s])

    // --- back wall set    
    useMemo(() => {
        let tempWallCloseSize;
        if (params.add_storage_check_right) {
            tempWallCloseSize = 0;
        } else {
            if (params.p_b_c_b_r_b === "One_Fourth_Close") {
                tempWallCloseSize = params.leanR_p_h / 4 * 3;
            } else if (params.p_b_c_b_r_b === "Gable") {
                tempWallCloseSize = params.leanR_p_h - 0.2;
            } else if (params.p_b_c_b_r_b === "Half_Close") {
                tempWallCloseSize = params.leanR_p_h / 2;
            } else if (params.p_b_c_b_r_b === "Three_Fourth_Close") {
                tempWallCloseSize = params.leanR_p_h / 4;
            } else if (params.p_b_c_b_r_b === "Close") {
                tempWallCloseSize = 0;
            } else if (params.p_b_c_b_r_b === "Half Dutch End") {
                tempWallCloseSize = 0;
            } else if (params.p_b_c_b_r_b === "Half End") {
                tempWallCloseSize = 0;
            } else {
                tempWallCloseSize = -1;
            }
        }

        setBackWallCloseSize(tempWallCloseSize);
        dispatch(setWallCloseStateWrap({'RLBackWallCloseState': tempWallCloseSize}))
    }, [params.add_storage_check_right, params.p_b_c_b_r_b, params.leanR_p_h, params.p_r_s])

    // --- side wall set    
    useMemo(() => {
        let tempWallCloseSize = 0;
        if (params.p_b_c_b_r === 'Open' || typeof(params.p_b_c_b_r) === 'object') {
            if (params.p_r_s === 1) {
                tempWallCloseSize = params.leanR_p_h - 0.25;
            } else {
                tempWallCloseSize = params.leanR_p_h;
            }
        } else if (params.p_b_c_b_r === "One_Fourth_Close") {
            tempWallCloseSize = params.leanR_p_h / 4 * 3;
        } else if (params.p_b_c_b_r === "Half_Close") {
            tempWallCloseSize = params.leanR_p_h / 2;
        } else if (params.p_b_c_b_r === "Three_Fourth_Close") {
            tempWallCloseSize = params.leanR_p_h / 4;
        } else if (params.p_b_c_b_r === "Close") {
            tempWallCloseSize = 0;
        } else {
            tempWallCloseSize = params.leanR_p_h - 3 * params.p_b_c_b_r;
        }

        setSideWallCloseSize(tempWallCloseSize);
    }, [params.p_b_c_b_r, params.leanR_p_h, params.p_r_s])
    
    // --- porch state
    useMemo(() => {
        if (params.add_right_back_lean_porch) {
            setSideWallLeftPorchSize(params.leanR_p_w);
        } else {
            setSideWallLeftPorchSize(0);
        }
    }, [params.add_right_back_lean_porch, params.leanR_p_w, params.p_r_s])

    useMemo(() => {
        if (params.add_right_front_lean_porch) {
            setSideWallRightPorchSize(params.leanR_p_w);
        } else {
            setSideWallRightPorchSize(0);
        }
    }, [params.add_right_front_lean_porch, params.leanR_p_w, params.p_r_s])

    useMemo(() => {
        if (params.p_r_s === 1) {
            setOffSetHeight(-0.15)
            setThickness(-0.15)
        } else {
            if (sideJTrimState === true) {
                setOffSetHeight(0)
                setThickness(0)
            } else if (sideJTrimState === false) {
                setOffSetHeight(0)
                setThickness(0)
            }
        }
    }, [params.p_r_s, sideJTrimState])

    const mainColor = useMemo(() => (params.p_t_c.replace("0x","#")), [params.p_t_c]) 

    return (
        <>
        <group  position={[(params.p_w / 2 + params.leanR_p_w - 0.12 + 0.015 + wallThickness), 0, 0]} rotation={[0, Math.PI / 2, 0]}>
            <mesh name="front-wall-trim" >
                <extrudeGeometry args={[frontWallVrTrimModel, extrudeSettings(0.16)]} />
                <meshStandardMaterial  color={mainColor} side={THREE.DoubleSide} roughness={0.5} metalness={0.2} toneMapped={false} emissive={'#101010'} transparent={params.is_translusant || (controls.isCheckActiveTab == "doorwindow" && const_var.focusedSection !== 'rightLean')} opacity={0.02} />
            </mesh>
            <mesh name="back-wall-trim" position={[0, 0, 0]}>
                <extrudeGeometry args={[backWallVrTrimModel, extrudeSettings(0.16)]} />
                <meshStandardMaterial  color={mainColor} side={THREE.DoubleSide} roughness={0.5} metalness={0.2} toneMapped={false} emissive={'#101010'} transparent={params.is_translusant || (controls.isCheckActiveTab == "doorwindow" && const_var.focusedSection !== 'rightLean')} opacity={0.02} />
            </mesh>
            <mesh name="side-wall-left-trim" position={[0, 0, 0.015]}>
                <extrudeGeometry args={[sideWallVrLeftTrimModel, extrudeSettings(0.155)]} />
                <meshStandardMaterial  color={mainColor} side={THREE.DoubleSide} roughness={0.5} metalness={0.2} toneMapped={false} emissive={'#101010'} transparent={params.is_translusant || (controls.isCheckActiveTab == "doorwindow" && const_var.focusedSection !== 'rightLean')} opacity={0.02} />
            </mesh>
            <mesh name="side-wall-right-trim">
                <extrudeGeometry args={[sideWallVrRightTrimModel, extrudeSettings(0.16)]} />
                <meshStandardMaterial  color={mainColor} side={THREE.DoubleSide} roughness={0.5} metalness={0.2} toneMapped={false} emissive={'#101010'} transparent={params.is_translusant || (controls.isCheckActiveTab == "doorwindow" && const_var.focusedSection !== 'rightLean')} opacity={0.02} />
            </mesh>

            <mesh name="right-lean-front-trim" position={[(params.p_d - params.leanR_p_d) / 2 + 0.03, 0, -params.leanR_p_w]}>
                <extrudeGeometry args={[rightLeanFrontTrimModel, extrudeSettings(0.225)]} />
                <meshStandardMaterial  color={mainColor} side={THREE.DoubleSide} roughness={0.5} metalness={0.2} toneMapped={false} emissive={'#101010'} transparent={params.is_translusant || (controls.isCheckActiveTab == "doorwindow" && const_var.focusedSection !== 'rightLean')} opacity={0.02} />
            </mesh>

            <mesh name="right-lean-back-trim" position={[-(params.p_d - params.leanR_p_d) / 2 - 0.03, 0, -params.leanR_p_w]}>
                <extrudeGeometry args={[rightLeanBackTrimModel, extrudeSettings(0.225)]} />
                <meshStandardMaterial  color={mainColor} side={THREE.DoubleSide} roughness={0.5} metalness={0.2} toneMapped={false} emissive={'#101010'} transparent={params.is_translusant || (controls.isCheckActiveTab == "doorwindow" && const_var.focusedSection !== 'rightLean')} opacity={0.02} />
            </mesh>

            {sideJTrimState && jTrimSideModelObj.main &&
                <mesh name="side-wall-J-trim" geometry={jTrimSideModelObj.main}>
                    <meshStandardMaterial  color={mainColor} side={THREE.DoubleSide} roughness={0.5} metalness={0.2} toneMapped={false} emissive={'#101010'} transparent={params.is_translusant || (controls.isCheckActiveTab == "doorwindow" && const_var.focusedSection !== 'rightLean')} opacity={0.02} />
                </mesh>
            }
            {frontJTrimState && jTrimFrontModelObj.main &&
                <mesh name="front-wall-J-trim" geometry={jTrimFrontModelObj.main}>
                    <meshStandardMaterial  color={mainColor} side={THREE.DoubleSide} roughness={0.5} metalness={0.2} toneMapped={false} emissive={'#101010'} transparent={params.is_translusant || (controls.isCheckActiveTab == "doorwindow" && const_var.focusedSection !== 'rightLean')} opacity={0.02} />
                </mesh>
            }
            {backJTrimState && jTrimBackModelObj.main &&
                <mesh name="back-wall-J-trim" geometry={jTrimBackModelObj.main}>
                    <meshStandardMaterial  color={mainColor} side={THREE.DoubleSide} roughness={0.5} metalness={0.2} toneMapped={false} emissive={'#101010'} transparent={params.is_translusant || (controls.isCheckActiveTab == "doorwindow" && const_var.focusedSection !== 'rightLean')} opacity={0.02} />
                </mesh>
            }
            {params.add_storage_check_right &&
                <mesh name="storage-wall-trim" position={[-parseInt(params.add_storage_right) - 0.1 - offset, 0, -0.03]}>
                    <extrudeGeometry args={[backWallVrTrimModelTwo, extrudeSettings(0.24)]} />
                    <meshStandardMaterial  color={mainColor} side={THREE.DoubleSide} roughness={0.5} metalness={0.2} toneMapped={false} emissive={'#101010'} transparent={params.is_translusant || (controls.isCheckActiveTab == "doorwindow" && const_var.focusedSection !== 'rightLean')} opacity={0.02} />
                </mesh>
            }
            
            {params.p_w_c_n == true && (params.p_b_c_b_r == "Close" || params.add_storage_check_right) && jTrimSideModelObj.wainscot &&
                <mesh name="wainscotTrim" geometry={jTrimSideModelObj.wainscot} >
                    <meshStandardMaterial  color={wainscotColor} side={THREE.DoubleSide} roughness={0.5} metalness={0.2} toneMapped={false} emissive={'#101010'} transparent={params.is_translusant || (controls.isCheckActiveTab == "doorwindow" && const_var.focusedSection !== 'rightLean')} opacity={0.02} />
                </mesh>
            }
            {params.p_w_c_n == true && params.p_b_c_b_r_f == "Close" && jTrimFrontModelObj.wainscot &&
                <mesh name="R_L_F_W_wainscotTrim" geometry={jTrimFrontModelObj.wainscot} >
                    <meshStandardMaterial  color={wainscotColor} side={THREE.DoubleSide} roughness={0.5} metalness={0.2} toneMapped={false} emissive={'#101010'} transparent={params.is_translusant || (controls.isCheckActiveTab == "doorwindow" && const_var.focusedSection !== 'rightLean')} opacity={0.02} />
                </mesh>
            }
            {params.p_w_c_n == true && params.p_b_c_b_r_b == "Close" && jTrimBackModelObj.wainscot &&
                <mesh name="wainscotTrim" geometry={jTrimBackModelObj.wainscot} >
                    <meshStandardMaterial  color={wainscotColor} side={THREE.DoubleSide} roughness={0.5} metalness={0.2} toneMapped={false} emissive={'#101010'} transparent={params.is_translusant || (controls.isCheckActiveTab == "doorwindow" && const_var.focusedSection !== 'rightLean')} opacity={0.02} />
                </mesh>
            }
            {params.p_w_c_n == true && params.add_storage_check_right && storageFrontWall &&
                <mesh name="wainscotTrim" geometry={storageFrontWall} position={[-offset, 0, 0]}>
                    <meshStandardMaterial  color={wainscotColor} side={THREE.DoubleSide} roughness={0.5} metalness={0.2} toneMapped={false} emissive={'#101010'} transparent={params.is_translusant || (controls.isCheckActiveTab == "doorwindow" && const_var.focusedSection !== 'rightLean')} opacity={0.02} />
                </mesh>
            }
        </group>
            <mesh position={[ (params.leanR_p_w / 2 + params.p_w / 2), 0, params.leanR_p_d / 2 + 0.1]} >
                <extrudeGeometry args={[dutchDelModelFront, extrudeSettings(0.15)]}/>
                <meshStandardMaterial  color={mainColor} side={THREE.DoubleSide} roughness={0.5} metalness={0.2} toneMapped={false} emissive={'#101010'} transparent={params.is_translusant || (controls.isCheckActiveTab == "doorwindow" && const_var.focusedSection !== 'rightLean')} opacity={0.02} />
            </mesh>
            <mesh position={[ (params.leanR_p_w / 2 + params.p_w / 2), 0, - (params.leanR_p_d / 2 + 0.25)]} >
                <extrudeGeometry args={[dutchDelModelBack, extrudeSettings(0.15)]}/>
                <meshStandardMaterial  color={mainColor} side={THREE.DoubleSide} roughness={0.5} metalness={0.2} toneMapped={false} emissive={'#101010'} transparent={params.is_translusant || (controls.isCheckActiveTab == "doorwindow" && const_var.focusedSection !== 'rightLean')} opacity={0.02} />
            </mesh>
        </>
    )
}

export default TrimModel